import React from 'react';
import { Col, Row } from 'antd';
import { connect, useDispatch, useSelector } from 'react-redux';
import {
  deleteUserGroupsAction,
  getUserGroupsAction,
  saveUserGroupAction,
} from '../../actions/UserActions';
import EditableTable from '../../components/EditableTable/EditableTable';
import CustomAddNewPageContent from '../../components/Content/CustomAddNewPageContent';

const UserGroupsPage = () => {
  const dispatch = useDispatch();
  const { userGroups, userGroupLoading } = useSelector(store => ({
    userGroups: store.userReducer.userGroups,
    userGroupLoading: store.userReducer.userGroupLoading,
  }));

  return (
    <CustomAddNewPageContent title="User Groups" subTitle="User Management">
      <Row type="flex" justify="center">
        <Col span={12}>
          <EditableTable
            dataSource={userGroups}
            retrieveAll={data => dispatch(getUserGroupsAction(data))}
            save={data => dispatch(saveUserGroupAction(data))}
            delete={data => dispatch(deleteUserGroupsAction(data))}
            cardTitle="User Group List"
            loading={userGroupLoading}
            parentType="user"
          />
        </Col>
      </Row>
    </CustomAddNewPageContent>
  );
};

UserGroupsPage.propTypes = {
  // userGroups: PropTypes.array,
  // userGroupLoading: PropTypes.object,
  // getUserGroupsAction: PropTypes.func,
  // saveUserGroupAction: PropTypes.func,
  // deleteUserGroupsAction: PropTypes.func,
};

function mapStateToProps({ userReducer }) {
  const { userGroups, userGroupLoading } = userReducer;
  return { userGroups, userGroupLoading };
}
export default connect(mapStateToProps, {
  getUserGroupsAction,
  saveUserGroupAction,
  deleteUserGroupsAction,
})(UserGroupsPage);
